/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import AppBaseScreen from '../../components/AppBaseScreen';
import Calendar from 'react-calendar';
import './monthcalender.css';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, ThemeProvider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';
import AppScreenLoader from '../../components/AppScreenLoader';
import { logEvent } from '../../store/api';
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from '../../utils/events';
import { useLocation } from 'react-router-dom';
import { downloadMontlyStatements } from '../../store/actions/statements.actions';
import { showMessageBar } from '../../store/actions';
import { MESSAGE_BAR_TYPES } from '../../utils/constants';
import moment from 'moment';
import AppMenuItem from '../../components/AppMenuItem';
export default function Statements(props) {
    const account = useSelector(({ Auth }) => Auth?.account)
    const currentDate = new Date();
    const previousMonthDate = new Date(currentDate);
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1);
    const accounts = useSelector(({ Auth }) => Auth?.accounts);
    const [currentAccount, setCurrentAccount] = React.useState(account);
    const [loading, setLoading] = React.useState(false);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const maxDate = previousMonthDate;
    const [selectedDate, setSelectedDate] = React.useState(previousMonthDate);
    React.useEffect(() => {
        setCurrentAccount(account)
    }, [account])
    const handleChange = (date) => {
        setSelectedDate(date);
        handleDownload(date);
    };
    const onDownloadSuccess = () => {
        dispatch(showMessageBar(MESSAGE_BAR_TYPES.SUCCESS, 'File Downloaded.'))
        setLoading(false);
        logEvent({
            current: EVENTS.STATEMENTS.STATEMENT_DOWNLOADED,
            activity: ACTIVITY_DETAIL.STATEMENTS.STATEMENT_DOWNLOADED,
            meta: {
                data: {
                    pathname: location.pathname,
                    source: ACTIVITY_META['2FA']['FROM_STATEMENTS']
                }
            }
        });

    }
    const handleDownload = (date) => {
        try {
            setLoading(true);
            const payload = {
                month: moment(date).format('YYYY-MM-DD'),
                type: 'pdf'
            };
            dispatch(downloadMontlyStatements(payload, currentAccount?.payoutAccount?.id, onDownloadSuccess, () => setLoading(false)));
        } catch (e) {
            setLoading(false);
        }
    }
    const logStatementMenuLog = () => {
        logEvent({
            current: EVENTS.STATEMENTS.STATEMENT_MENU_OPENED,
            activity: ACTIVITY_DETAIL.STATEMENTS.STATEMENT_MENU_OPENED,
            meta: {
                data: {
                    pathname: location.pathname,
                    source: ACTIVITY_META['2FA']['FROM_MENU']
                }
            }
        });
    }
    const handleMerchantChange = (account) => {
        setCurrentAccount(account)
    }
    React.useEffect(() => {
        logStatementMenuLog();
    }, []);
    if (loading) {
        return <AppScreenLoader />;
    }
    return <AppBaseScreen>
        <ThemeProvider theme={theme}>
            <Container maxWidth="sm" sx={{ marginTop: 15 }}>
                {
                    !!(accounts?.length > 1) && <AppMenuItem
                        items={accounts}
                        onItemSelect={handleMerchantChange}
                        defaultValue={currentAccount}
                        labelKey="payoutAccount"
                        identifierKey="payoutAccount"
                        labelKey2Identifier={"totalBalance"}
                        labelKey2Text={"availableBalance"}
                    />
                }
                <Typography textAlign={'left'} color={'#F8F8F8'} marginTop={3} textTransform={'capitalize'}>{currentAccount?.merchant?.companyName || currentAccount?.merchant?.username}&nbsp;{t('monthlyStatement')}</Typography>
                <Box display={'flex'} justifyContent={'center'} marginTop={2} flexDirection={'column'}>
                    <Typography variant='subtitle2' textAlign={'left'} color={'#F8F8F8'}>{t("SelectMonth")}</Typography>
                    <Calendar
                        value={selectedDate}
                        minDate={new Date(currentAccount?.openedOn)}
                        view="year"
                        onClickMonth={handleChange}
                        maxDate={maxDate}
                    />
                </Box>
            </Container>
        </ThemeProvider>
    </AppBaseScreen>
}